import catalogTemplateUrl from './catalog.tpl.html';
import { MetricMetadata as sitemap } from '../../../app/routing/Sitemaps';
import { ngRoute } from '../../../app/routing/ngRoute';
import { Capability } from '@splunk/olly-services/lib/services/CurrentUser/Capabilities';

export const catalog = {
    templateUrl: catalogTemplateUrl,
    bindings: {
        setHierarchicalNav: '<',
    },
    controller: [
        '$scope',
        'featureEnabled',
        'sidebarService',
        'catalogDataService',
        'currentUser',
        function ($scope, featureEnabled, sidebarService, catalogDataService, currentUser) {
            $scope.sidebarService = sidebarService;
            sidebarService.showSidebar = true;
            $scope.dataService = catalogDataService;
            // This is used to share context between the right side and the left side
            // of the catalog (catalog sidebar and catalog preview)
            $scope.sharableObject = {};

            const $ctrl = this;
            $ctrl.loading = true;
            $ctrl.forbidden = false;
            $ctrl.magneticPageHeader = featureEnabled('magneticPageHeader');
            $ctrl.headerNavigation = [
                {
                    id: sitemap.map.id,
                    label: sitemap.map.label,
                },
            ];
            $ctrl.description =
                'The Metadata Catalog allows you to explore and modify your metadata, such as dimensions, properties, and tags.';
            const params = new URLSearchParams(ngRoute?.history?.location?.search);
            const showBackNavigation = params.has('redirectedFrom');

            $ctrl.$onInit = () => {
                checkCapability();
                if (showBackNavigation) {
                    $ctrl.setHierarchicalNav(sitemap.name, sitemap.IDs.metricMetadata);
                }
            };

            $ctrl.$onDestroy = () => {
                $ctrl.setHierarchicalNav();
            };

            function checkCapability() {
                currentUser.userCapabilities().then((userCapabilities) => {
                    const requiredCapabilities = [
                        Capability.READ_GLOBAL_BUCKET_SEARCH,
                        Capability.EXECUTE_SIGNAL_FLOW,
                        Capability.READ_METRIC,
                        Capability.READ_DIMENSION,
                        Capability.READ_DETECTOR,
                        Capability.READ_TAG,
                        Capability.READ_ALERT,
                        Capability.READ_DASHBOARD_DATA_LINK,
                        Capability.READ_GLOBAL_DATA_LINK,
                    ];

                    const hasAllCapabilities = requiredCapabilities.every((cap) =>
                        userCapabilities.includes(cap)
                    );

                    if (!hasAllCapabilities) {
                        $ctrl.forbidden = true;
                    }
                    $ctrl.loading = false;
                });
            }
        },
    ],
};
